var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudiesGpb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 80.5",
    style: {
      enableBackground: "new 0 0 160 80.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000073001814163825061840000007490280613994387872_);}\n\t.st2{fill:url(#SVGID_00000132786916071093585440000013912994991237870241_);}\n\t.st3{fill:url(#SVGID_00000041290855010038243340000013988898669652031160_);}\n\t.st4{fill:url(#SVGID_00000147205886413685991780000008314448838692775318_);}\n\t.st5{fill:url(#SVGID_00000132798951946919437180000018013869087671910547_);}\n\t.st6{fill:url(#SVGID_00000101087757277177375070000018021843884989687480_);}\n\t.st7{fill:url(#SVGID_00000097470962192696930050000014472051404804166277_);}\n\t.st8{fill:url(#SVGID_00000111159020393214769150000007831387129653529991_);}\n\t.st9{fill:url(#SVGID_00000180337335170054302620000004802917082232096916_);}\n\t.st10{fill:url(#SVGID_00000113343049870043460100000011441604766199571135_);}\n\t.st11{fill:url(#SVGID_00000117671174638104055800000004751516103703232897_);}\n\t.st12{fill:url(#SVGID_00000043435084701296210310000008113567172508747669_);}\n\t.st13{fill:url(#SVGID_00000127733738394723575070000013009071985485832119_);}\n\t.st14{fill:url(#SVGID_00000041989471594206100700000015739570361807902626_);}\n\t.st15{fill:url(#SVGID_00000183944133269779081400000004829894116449173439_);}\n\t.st16{fill:url(#SVGID_00000044866743310833967380000018102284512678937747_);}\n\t.st17{fill:url(#SVGID_00000043424122933019001020000002468545675171690680_);}\n\t.st18{fill:url(#SVGID_00000063609018166921383320000013684065736931743126_);}\n\t.st19{fill:url(#SVGID_00000061437122713823273060000011375421044201511838_);}\n\t.st20{fill:url(#SVGID_00000137832968129590297820000007440032647748929434_);}\n\t.st21{fill:url(#SVGID_00000085231870362102714900000008044057913783608767_);}\n\t.st22{fill:url(#SVGID_00000158008184896612589790000005095795849566483876_);}\n\t.st23{fill:url(#SVGID_00000011029175944682628750000016149376263505687979_);}\n\t.st24{fill:url(#SVGID_00000050624382080675745280000015072602909606623644_);}\n\t.st25{fill:url(#SVGID_00000160161100477522646450000016281137456886044046_);}\n\t.st26{fill:url(#SVGID_00000173130172208918351710000015127641007131984800_);}\n\t.st27{fill:url(#SVGID_00000130609181942861424760000015173063581114990776_);}\n\t.st28{fill:url(#SVGID_00000179636322650186160000000017980736969875681976_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.4147,
    y1: 71.184,
    x2: 3.4147,
    y2: 78.114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,75.1h2.8l-0.1,0.5c-0.2,0-0.3,0.1-0.4,0.2C6.1,75.9,6,76.1,6,76.4l-0.5,1.6H5.4l-0.5-0.4 c-0.4,0.2-0.7,0.3-1.1,0.4c-0.4,0.1-0.8,0.1-1.1,0.1c-0.8,0-1.4-0.2-1.9-0.7C0.2,76.9,0,76.3,0,75.5c0-0.7,0.2-1.4,0.6-2.1 c0.4-0.7,0.9-1.3,1.5-1.7c0.6-0.4,1.3-0.6,2-0.6c0.8,0,1.4,0.3,1.9,0.8c0.1-0.2,0.2-0.4,0.3-0.7h0.5l-0.5,2.3H5.8 c0-0.8-0.2-1.3-0.5-1.5c-0.3-0.3-0.6-0.4-0.9-0.4c-0.4,0-0.9,0.2-1.3,0.6c-0.4,0.4-0.7,1-1,1.7c-0.2,0.7-0.4,1.4-0.4,1.9 c0,0.5,0.1,0.9,0.3,1.2c0.2,0.3,0.5,0.4,0.9,0.4c0.4,0,0.8-0.2,1-0.5c0.3-0.3,0.4-0.6,0.4-1c0-0.2-0.2-0.4-0.6-0.4L4,75.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153673791386198914820000012777682447481792654_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.4406,
    y1: 73.798,
    x2: 8.4406,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153673791386198914820000012777682447481792654_)"
    },
    d: "M7.8,76.5c0,0.1,0,0.2,0,0.3 c0,0.3,0.1,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.7-0.2c0.2-0.1,0.5-0.3,0.7-0.6h0.6c-0.3,0.4-0.6,0.7-1.1,1 c-0.5,0.3-1,0.4-1.5,0.4c-0.5,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.4-0.5-0.4-1c0-0.7,0.3-1.4,1-2.1c0.7-0.7,1.4-1,2.3-1 c0.4,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.3,0.3,0.6c0,0.4-0.3,0.8-0.8,1.2C9.3,76.1,8.6,76.3,7.8,76.5z M7.9,75.9 c0.4-0.1,0.7-0.2,1-0.5c0.3-0.3,0.5-0.6,0.5-0.8c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.2,0-0.5,0.1-0.7,0.4 C8.2,75,8.1,75.4,7.9,75.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001657604163535612430000018136482780228827272_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.1796,
    y1: 73.798,
    x2: 13.1796,
    y2: 78.0245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001657604163535612430000018136482780228827272_)"
    },
    d: "M10.5,78l0.9-3.1c0-0.2,0.1-0.3,0.1-0.3 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0c-0.2,0-0.4,0.2-0.6,0.7h-0.4c0.3-0.9,0.9-1.4,1.6-1.4c0.3,0,0.5,0.1,0.6,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.3-0.1,0.7-0.3,1.3c0.7-1.3,1.5-2,2.2-2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.1,0,0.3-0.1,0.5l-0.5,1.6c-0.1,0.3-0.1,0.5-0.1,0.5c0,0.1,0,0.2,0.1,0.2c0.2,0,0.4-0.2,0.6-0.6H16c-0.4,0.9-1,1.3-1.8,1.3 c-0.3,0-0.5-0.1-0.7-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.3,0.1-0.6l0.4-1.5C14,75.1,14,75,14,74.9c0-0.1-0.1-0.1-0.2-0.1 c-0.2,0-0.6,0.4-1,1.1c-0.4,0.7-0.7,1.3-0.9,1.8L11.9,78H10.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085227776102752601810000016558485315416417164_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.195,
    y1: 73.798,
    x2: 18.195,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085227776102752601810000016558485315416417164_)"
    },
    d: "M15.8,76.3c0-0.3,0.1-0.7,0.3-1.1 c0.2-0.4,0.5-0.7,0.9-1s0.9-0.4,1.5-0.4c0.7,0,1.3,0.2,1.6,0.5c0.3,0.4,0.5,0.8,0.5,1.3c0,0.7-0.3,1.3-0.8,1.8 c-0.5,0.5-1.2,0.8-2,0.8c-0.6,0-1.1-0.2-1.5-0.5C16,77.4,15.8,76.9,15.8,76.3z M17.2,76.8c0,0.3,0.1,0.5,0.2,0.7 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.7-0.3,1-0.9c0.3-0.6,0.4-1.1,0.4-1.6c0-0.3-0.1-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.4,0-0.8,0.3-1,1C17.3,75.9,17.2,76.4,17.2,76.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151545171660723418610000017655688644800062358_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9979,
    y1: 73.798,
    x2: 24.9979,
    y2: 78.0196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151545171660723418610000017655688644800062358_)"
    },
    d: "M20.5,78l0.9-2.9 c0.1-0.2,0.1-0.3,0.1-0.4c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.2-0.2,0.3-0.3,0.4h-0.5 c0.5-0.9,1-1.4,1.8-1.4c0.3,0,0.5,0.1,0.6,0.2c0.2,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.5-0.2,0.9c0.7-1.1,1.4-1.6,2.2-1.6 c0.3,0,0.5,0.1,0.7,0.2c0.2,0.2,0.3,0.4,0.3,0.7c0,0.2,0,0.4-0.1,0.7c0.7-1.1,1.5-1.7,2.4-1.7c0.3,0,0.5,0.1,0.7,0.2 c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1,0,0.3-0.1,0.6l-0.5,1.6c-0.1,0.2-0.1,0.4-0.1,0.4c0,0.1,0,0.1,0.1,0.1c0.1,0,0.2,0,0.3-0.1 c0.1-0.1,0.2-0.2,0.3-0.4h0.5c-0.2,0.4-0.5,0.7-0.8,0.9c-0.3,0.2-0.7,0.3-1,0.3c-0.2,0-0.5-0.1-0.6-0.2c-0.2-0.1-0.3-0.3-0.3-0.5 c0-0.1,0-0.3,0.1-0.6l0.4-1.5c0-0.2,0.1-0.3,0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.8,0.3-1.2,1c-0.5,0.6-0.9,1.4-1.1,2.3h-1.4 l0.7-2.5c0.1-0.2,0.1-0.4,0.1-0.5c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.3,0-0.7,0.3-1.1,0.9C22.6,76.3,22.3,77,22,78 H20.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116927584950678696310000007016508166037767348_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8463,
    y1: 71.1816,
    x2: 30.8463,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116927584950678696310000007016508166037767348_)"
    },
    d: "M31.7,76.8h0.5c-0.4,0.9-1,1.3-1.7,1.3 c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.2-0.3-0.2-0.6c0-0.1,0.1-0.4,0.2-0.8l0.6-1.7c0-0.1,0.1-0.2,0.1-0.3s0-0.1,0-0.1 c0,0,0,0-0.1,0c-0.2,0-0.4,0.2-0.6,0.6h-0.5c0.4-0.9,1-1.4,1.8-1.4c0.3,0,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.2-0.1,0.4-0.2,0.8l-0.6,1.6c-0.1,0.2-0.1,0.4-0.1,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2 C31.5,77.1,31.6,76.9,31.7,76.8z M32.5,71.9c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2 C31,72.3,31,72.2,31,71.9c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2C32.4,71.6,32.5,71.7,32.5,71.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014594274116336462340000001932789927139237555_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1201,
    y1: 73.798,
    x2: 34.1201,
    y2: 78.1325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014594274116336462340000001932789927139237555_)"
    },
    d: "M35.5,76.8h0.6c-0.3,0.5-0.7,0.8-1.1,1 c-0.4,0.2-0.9,0.3-1.4,0.3c-0.6,0-1-0.1-1.3-0.3c-0.3-0.2-0.4-0.6-0.4-1c0-0.5,0.2-1,0.5-1.4c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,0.9-0.4,1.4-0.4c0.4,0,0.8,0.1,1,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.3,0.2-0.5,0.2 c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.3-0.1 c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.4,0.5-0.5,1s-0.2,0.9-0.2,1.1c0,0.3,0.1,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.5-0.1,0.7-0.2C35,77.2,35.2,77,35.5,76.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122679523613529569390000011451893823099914372_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.128,
    y1: 73.798,
    x2: 38.128,
    y2: 78.1325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122679523613529569390000011451893823099914372_)"
    },
    d: "M35.9,77.1c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.2,0.5-0.2c0.4,0,0.6,0.2,0.6,0.7c0.1,0.3,0.3,0.5,0.7,0.5c0.2,0,0.4,0,0.5-0.1c0.1-0.1,0.2-0.2,0.2-0.4 c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.3-0.2-0.6-0.4c-0.5-0.3-0.8-0.5-0.9-0.7c-0.2-0.2-0.2-0.4-0.2-0.7c0-0.4,0.2-0.7,0.5-0.9 c0.4-0.2,0.9-0.4,1.5-0.4c0.6,0,1,0.1,1.2,0.2c0.3,0.2,0.4,0.4,0.4,0.6c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.3,0-0.5-0.2-0.6-0.5c0-0.3-0.2-0.4-0.6-0.4c-0.2,0-0.4,0-0.5,0.1C38,74.4,38,74.5,38,74.7c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.2,0.2,0.5,0.4c0.5,0.3,0.8,0.5,0.9,0.8c0.1,0.2,0.2,0.5,0.2,0.7c0,0.4-0.2,0.7-0.6,1c-0.4,0.3-0.9,0.4-1.6,0.4 c-0.5,0-1-0.1-1.3-0.3C36,77.7,35.9,77.4,35.9,77.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136386234216443096080000013293735248070288809_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.4246,
    y1: 76.6254,
    x2: 40.4246,
    y2: 79.9193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136386234216443096080000013293735248070288809_)"
    },
    d: "M39.2,79.9l0.1-0.5 c0.4,0,0.7-0.1,1.1-0.4c0.3-0.3,0.5-0.5,0.5-0.8c0-0.1,0-0.1-0.1-0.1l-0.1,0c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.2-0.3-0.2-0.6 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.3,0.5,0.3,0.8c0,0.6-0.2,1.1-0.7,1.5 C40.5,79.7,39.9,79.9,39.2,79.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175281579572436994360000013497289482281566348_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.1464,
    y1: 71.319,
    x2: 47.1464,
    y2: 77.9754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175281579572436994360000013497289482281566348_)"
    },
    d: "M46.7,75l-0.4,1.5 c-0.1,0.2-0.1,0.4-0.1,0.4c0,0.3,0.2,0.5,0.7,0.5L46.7,78h-3.1l0.2-0.5c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.3,0.3-0.7l1.2-4.1 c0-0.1,0-0.2,0-0.3c0-0.3-0.2-0.5-0.7-0.5l0.2-0.5h2.5c0.6,0,1.1,0,1.5,0.1c0.4,0.1,0.7,0.3,0.9,0.6c0.2,0.3,0.3,0.6,0.3,1 c0,0.5-0.2,1-0.7,1.4c-0.5,0.4-1.2,0.6-2.3,0.6H46.7z M46.9,74.5h0.5c0.6,0,1-0.2,1.2-0.5c0.3-0.4,0.4-0.7,0.4-1.2 c0-0.3-0.1-0.5-0.3-0.7s-0.4-0.2-0.8-0.2h-0.2L46.9,74.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124154929353844810370000002228991209072994977_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.618,
    y1: 73.798,
    x2: 51.618,
    y2: 77.9754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124154929353844810370000002228991209072994977_)"
    },
    d: "M49.6,78l0.8-2.8 c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1,0-0.2-0.1-0.2c-0.2,0-0.5,0.2-0.7,0.7h-0.4c0.3-0.5,0.6-0.9,0.9-1.1c0.4-0.2,0.7-0.4,1-0.4 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.7-0.3,1.3c0.7-1.3,1.4-2,1.9-2c0.2,0,0.3,0.1,0.4,0.2 c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2 c-0.2,0-0.5,0.4-0.9,1.1c-0.4,0.7-0.7,1.4-0.8,2H49.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173880726691781669380000002264585081599804850_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.7512,
    y1: 73.798,
    x2: 55.7512,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173880726691781669380000002264585081599804850_)"
    },
    d: "M53.3,76.3c0-0.3,0.1-0.7,0.3-1.1 c0.2-0.4,0.5-0.7,0.9-1c0.4-0.3,0.9-0.4,1.5-0.4c0.7,0,1.3,0.2,1.6,0.5c0.3,0.4,0.5,0.8,0.5,1.3c0,0.7-0.3,1.3-0.8,1.8 c-0.5,0.5-1.2,0.8-2,0.8c-0.6,0-1.1-0.2-1.5-0.5C53.5,77.4,53.3,76.9,53.3,76.3z M54.7,76.8c0,0.3,0.1,0.5,0.2,0.7 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.7-0.3,1-0.9c0.3-0.6,0.4-1.1,0.4-1.6c0-0.3-0.1-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.4,0-0.8,0.3-1,1C54.9,75.9,54.7,76.4,54.7,76.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153695024247786634240000010197952484650372753_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.8719,
    y1: 72.4579,
    x2: 59.8719,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153695024247786634240000010197952484650372753_)"
    },
    d: "M60.6,76.6h0.5c-0.1,0.4-0.4,0.7-0.7,1.1 c-0.3,0.3-0.7,0.5-1.1,0.5c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.4-0.3-0.7c0-0.2,0.1-0.5,0.2-1l0.5-1.7h-0.8l0.2-0.5h0.8 l0.4-1.5h1.4L60.6,74h0.9l-0.2,0.5h-0.9l-0.6,2c-0.1,0.4-0.2,0.6-0.2,0.7c0,0.1,0,0.1,0,0.2c0,0,0.1,0.1,0.1,0.1 C60.1,77.4,60.4,77.1,60.6,76.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076572148258061856490000009344279830403035034_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.0381,
    y1: 73.798,
    x2: 63.0381,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076572148258061856490000009344279830403035034_)"
    },
    d: "M62.4,76.5c0,0.1,0,0.2,0,0.3 c0,0.3,0.1,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.7-0.2c0.2-0.1,0.5-0.3,0.7-0.6H65c-0.3,0.4-0.6,0.7-1.1,1 c-0.5,0.3-1,0.4-1.5,0.4c-0.5,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.4-0.5-0.4-1c0-0.7,0.3-1.4,1-2.1c0.7-0.7,1.4-1,2.3-1 c0.4,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.3,0.3,0.6c0,0.4-0.3,0.8-0.8,1.2C63.9,76.1,63.2,76.3,62.4,76.5z M62.5,75.9 c0.4-0.1,0.7-0.2,1-0.5c0.3-0.3,0.5-0.6,0.5-0.8c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.2,0-0.5,0.1-0.7,0.4 C62.8,75,62.7,75.4,62.5,75.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091735946289625243920000003262464262382538640_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5316,
    y1: 73.798,
    x2: 67.5316,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091735946289625243920000003262464262382538640_)"
    },
    d: "M65.1,76.3c0-0.3,0.1-0.7,0.3-1.1 c0.2-0.4,0.5-0.7,0.9-1c0.4-0.3,0.9-0.4,1.5-0.4c0.7,0,1.3,0.2,1.6,0.5c0.3,0.4,0.5,0.8,0.5,1.3c0,0.7-0.3,1.3-0.8,1.8 c-0.5,0.5-1.2,0.8-2,0.8c-0.6,0-1.1-0.2-1.5-0.5C65.3,77.4,65.1,76.9,65.1,76.3z M66.5,76.8c0,0.3,0.1,0.5,0.2,0.7 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.7-0.3,1-0.9c0.3-0.6,0.4-1.1,0.4-1.6c0-0.3-0.1-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.4,0-0.8,0.3-1,1C66.7,75.9,66.5,76.4,66.5,76.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023263152919261117670000017729949665828842636_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.3345,
    y1: 73.798,
    x2: 74.3345,
    y2: 78.0196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023263152919261117670000017729949665828842636_)"
    },
    d: "M69.9,78l0.9-2.9 c0.1-0.2,0.1-0.3,0.1-0.4c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.2-0.2,0.3-0.3,0.4h-0.5 c0.5-0.9,1-1.4,1.8-1.4c0.3,0,0.5,0.1,0.6,0.2c0.2,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.5-0.2,0.9c0.7-1.1,1.4-1.6,2.2-1.6 c0.3,0,0.5,0.1,0.7,0.2c0.2,0.2,0.3,0.4,0.3,0.7c0,0.2,0,0.4-0.1,0.7c0.7-1.1,1.5-1.7,2.4-1.7c0.3,0,0.5,0.1,0.7,0.2 c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1,0,0.3-0.1,0.6l-0.5,1.6c-0.1,0.2-0.1,0.4-0.1,0.4c0,0.1,0,0.1,0.1,0.1c0.1,0,0.2,0,0.3-0.1 c0.1-0.1,0.2-0.2,0.3-0.4H79c-0.2,0.4-0.5,0.7-0.8,0.9c-0.3,0.2-0.7,0.3-1,0.3c-0.2,0-0.5-0.1-0.6-0.2c-0.2-0.1-0.3-0.3-0.3-0.5 c0-0.1,0-0.3,0.1-0.6l0.4-1.5c0-0.2,0.1-0.3,0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.8,0.3-1.2,1c-0.5,0.6-0.9,1.4-1.1,2.3H73 l0.7-2.5c0.1-0.2,0.1-0.4,0.1-0.5c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.3,0-0.7,0.3-1.1,0.9C72,76.3,71.6,77,71.3,78 H69.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061444074779950963260000000602578985679532444_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.1829,
    y1: 71.1816,
    x2: 80.1829,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061444074779950963260000000602578985679532444_)"
    },
    d: "M81,76.8h0.5c-0.4,0.9-1,1.3-1.7,1.3 c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.2-0.3-0.2-0.6c0-0.1,0.1-0.4,0.2-0.8l0.6-1.7c0-0.1,0.1-0.2,0.1-0.3s0-0.1,0-0.1 c0,0,0,0-0.1,0c-0.2,0-0.4,0.2-0.6,0.6h-0.5c0.4-0.9,1-1.4,1.8-1.4c0.3,0,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.2-0.1,0.4-0.2,0.8l-0.6,1.6c-0.1,0.2-0.1,0.4-0.1,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2 C80.8,77.1,80.9,76.9,81,76.8z M81.8,71.9c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2C81.7,71.6,81.8,71.7,81.8,71.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154428064792466934650000009371533529626443692_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.4567,
    y1: 73.798,
    x2: 83.4567,
    y2: 78.1325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154428064792466934650000009371533529626443692_)"
    },
    d: "M84.8,76.8h0.6c-0.3,0.5-0.7,0.8-1.1,1 c-0.4,0.2-0.9,0.3-1.4,0.3c-0.6,0-1-0.1-1.3-0.3c-0.3-0.2-0.4-0.6-0.4-1c0-0.5,0.2-1,0.5-1.4c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,0.9-0.4,1.4-0.4c0.4,0,0.8,0.1,1,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.3,0.2-0.5,0.2 c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.3-0.1 c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.4,0.5-0.5,1c-0.2,0.5-0.2,0.9-0.2,1.1c0,0.3,0.1,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.5-0.1,0.7-0.2C84.4,77.2,84.6,77,84.8,76.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129174029737786616570000003246864819079374240_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.4646,
    y1: 73.798,
    x2: 87.4646,
    y2: 78.1325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129174029737786616570000003246864819079374240_)"
    },
    d: "M85.2,77.1c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.2,0.5-0.2c0.4,0,0.6,0.2,0.6,0.7c0.1,0.3,0.3,0.5,0.7,0.5c0.2,0,0.4,0,0.5-0.1c0.1-0.1,0.2-0.2,0.2-0.4 c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.3-0.2-0.6-0.4c-0.5-0.3-0.8-0.5-0.9-0.7c-0.2-0.2-0.2-0.4-0.2-0.7c0-0.4,0.2-0.7,0.5-0.9 c0.4-0.2,0.9-0.4,1.5-0.4c0.6,0,1,0.1,1.2,0.2c0.3,0.2,0.4,0.4,0.4,0.6c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.3,0-0.5-0.2-0.6-0.5c0-0.3-0.2-0.4-0.6-0.4c-0.2,0-0.4,0-0.5,0.1c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.2,0.2,0.5,0.4c0.5,0.3,0.8,0.5,0.9,0.8c0.1,0.2,0.2,0.5,0.2,0.7c0,0.4-0.2,0.7-0.6,1c-0.4,0.3-0.9,0.4-1.6,0.4 c-0.5,0-1-0.1-1.3-0.3C85.4,77.7,85.2,77.4,85.2,77.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171681705617186743800000013607054728819353487_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.8765,
    y1: 71.481,
    x2: 94.8765,
    y2: 78.1128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171681705617186743800000013607054728819353487_)"
    },
    d: "M96.1,76.5c0.3,0.3,0.5,0.5,0.8,0.5 c0.3,0,0.6-0.2,0.8-0.6h0.6c-0.2,0.5-0.4,0.9-0.8,1.2c-0.4,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1.3-0.7c-0.6,0.5-1.2,0.7-1.9,0.7 c-0.5,0-1-0.2-1.3-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.8,0.7-1.6,2-2.2c-0.1-0.3-0.2-0.7-0.2-1c0-0.5,0.2-0.9,0.5-1.3 c0.3-0.4,0.7-0.5,1.3-0.5c0.4,0,0.8,0.1,1,0.3c0.2,0.2,0.4,0.5,0.4,0.8c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.4-0.4,0.5 c-0.2,0.1-0.5,0.3-1,0.6c0.3,0.7,0.7,1.4,1,1.9c0.5-0.6,0.8-1.1,0.8-1.3c0-0.2-0.1-0.3-0.4-0.3l0.2-0.5h2l-0.2,0.5 c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.1-0.5,0.5-0.9,1C96.5,76.1,96.3,76.4,96.1,76.5z M94.7,77c-0.4-0.5-0.8-1.2-1.2-2.2 c-0.5,0.3-0.8,0.7-0.8,1.2c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.9,0.4C94.2,77.3,94.5,77.2,94.7,77z M94.6,73.7 c0.7-0.4,1-0.8,1-1.2c0-0.2-0.1-0.3-0.2-0.4C95.4,72,95.2,72,95.1,72c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0.1-0.2,0.4-0.2,0.7 C94.4,73.1,94.5,73.4,94.6,73.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106141249353710204320000016143161916186956167_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.938,
    y1: 71.319,
    x2: 102.938,
    y2: 77.9754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106141249353710204320000016143161916186956167_)"
    },
    d: "M104.1,74.5c0.4,0.1,0.8,0.2,1.1,0.5 c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1.1c-0.3,0.3-0.6,0.6-1,0.7c-0.4,0.1-0.8,0.2-1.2,0.2h-3.3l0.2-0.5 c0.2,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.3,0.3-0.7l1.2-4.1c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.3-0.2-0.3c-0.1-0.1-0.2-0.1-0.4-0.1 l0.2-0.5h2.7c0.5,0,0.8,0,1.1,0.1c0.3,0.1,0.5,0.2,0.7,0.5c0.2,0.2,0.3,0.5,0.3,0.9c0,0.5-0.2,0.8-0.5,1.1 C105.4,74.2,104.8,74.4,104.1,74.5z M102.7,74.8l-0.6,1.9c0,0.1-0.1,0.3-0.1,0.3c0,0.2,0.1,0.3,0.2,0.3c0.1,0.1,0.3,0.1,0.4,0.1 c0.4,0,0.7-0.2,0.9-0.6c0.2-0.4,0.3-0.9,0.3-1.3c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.1-0.6-0.1H102.7z M103.6,71.9l-0.7,2.3 c0.1,0,0.2,0,0.2,0c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.4-0.3,0.5-0.6c0.1-0.3,0.2-0.6,0.2-0.9c0-0.2-0.1-0.4-0.2-0.5 c-0.1-0.1-0.3-0.2-0.6-0.2H103.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181068462599028106700000015354849876485908152_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.1668,
    y1: 71.1816,
    x2: 107.1668,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181068462599028106700000015354849876485908152_)"
    },
    d: "M108,76.8h0.5c-0.4,0.9-1,1.3-1.7,1.3 c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.2-0.3-0.2-0.6c0-0.1,0.1-0.4,0.2-0.8l0.6-1.7c0-0.1,0.1-0.2,0.1-0.3s0-0.1,0-0.1 c0,0,0,0-0.1,0c-0.2,0-0.4,0.2-0.6,0.6h-0.5c0.4-0.9,1-1.4,1.8-1.4c0.3,0,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.2-0.1,0.4-0.2,0.8l-0.6,1.6c-0.1,0.2-0.1,0.4-0.1,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2 C107.8,77.1,107.9,76.9,108,76.8z M108.8,71.9c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 C108.7,71.6,108.8,71.7,108.8,71.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072256820880382314370000015516724033349079457_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.708,
    y1: 73.798,
    x2: 110.708,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072256820880382314370000015516724033349079457_)"
    },
    d: "M108.3,76.3c0-0.3,0.1-0.7,0.3-1.1 c0.2-0.4,0.5-0.7,0.9-1c0.4-0.3,0.9-0.4,1.5-0.4c0.7,0,1.3,0.2,1.6,0.5c0.3,0.4,0.5,0.8,0.5,1.3c0,0.7-0.3,1.3-0.8,1.8 c-0.5,0.5-1.2,0.8-2,0.8c-0.6,0-1.1-0.2-1.5-0.5C108.5,77.4,108.3,76.9,108.3,76.3z M109.7,76.8c0,0.3,0.1,0.5,0.2,0.7 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.7-0.3,1-0.9c0.3-0.6,0.4-1.1,0.4-1.6c0-0.3-0.1-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.4,0-0.8,0.3-1,1C109.8,75.9,109.7,76.4,109.7,76.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067951069744183461760000006599611573395622030_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.5044,
    y1: 71.1816,
    x2: 114.5044,
    y2: 78.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067951069744183461760000006599611573395622030_)"
    },
    d: "M115.3,76.8h0.5c-0.4,0.9-1,1.3-1.7,1.3 c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.2-0.3-0.2-0.6c0-0.1,0.1-0.4,0.2-0.8l0.6-1.7c0-0.1,0.1-0.2,0.1-0.3s0-0.1,0-0.1 c0,0,0,0-0.1,0c-0.2,0-0.4,0.2-0.6,0.6h-0.5c0.4-0.9,1-1.4,1.8-1.4c0.3,0,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.2-0.1,0.4-0.2,0.8l-0.6,1.6c-0.1,0.2-0.1,0.4-0.1,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2 C115.2,77.1,115.3,76.9,115.3,76.8z M116.1,71.9c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 C116.1,71.6,116.1,71.7,116.1,71.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140010679365119047880000011875403049553490867_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.2911,
    y1: 73.798,
    x2: 118.2911,
    y2: 78.0245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140010679365119047880000011875403049553490867_)"
    },
    d: "M115.6,78l0.9-3.1c0-0.2,0.1-0.3,0.1-0.3 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0c-0.2,0-0.4,0.2-0.6,0.7h-0.4c0.3-0.9,0.9-1.4,1.7-1.4c0.3,0,0.5,0.1,0.6,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.3-0.1,0.7-0.3,1.3c0.7-1.3,1.5-2,2.2-2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.1,0,0.3-0.1,0.5l-0.5,1.6c-0.1,0.3-0.1,0.5-0.1,0.5c0,0.1,0,0.2,0.1,0.2c0.2,0,0.4-0.2,0.6-0.6h0.5c-0.4,0.9-1,1.3-1.8,1.3 c-0.3,0-0.5-0.1-0.7-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.3,0.1-0.6l0.4-1.5c0.1-0.2,0.1-0.3,0.1-0.3c0-0.1-0.1-0.1-0.2-0.1 c-0.2,0-0.6,0.4-1,1.1c-0.4,0.7-0.7,1.3-0.9,1.8L117,78H115.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078735393664831728750000011687971768824197517_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.0777,
    y1: 71.1816,
    x2: 122.0777,
    y2: 80.4788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078735393664831728750000011687971768824197517_)"
    },
    d: "M123.1,74.5l-0.5,2.2 c-0.3,1.3-0.6,2.2-1.1,2.8c-0.5,0.6-1.1,0.9-1.9,0.9c-0.4,0-0.7-0.1-0.8-0.2c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0.1-0.3,0.2-0.5 c0.1-0.1,0.3-0.2,0.5-0.2c0.4,0,0.6,0.2,0.6,0.6c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.4-0.4c0.1-0.3,0.3-0.8,0.5-1.7l0.1-0.7 c0-0.2,0.1-0.3,0.1-0.4l0.5-2.3h-0.6l0.2-0.5h0.6c0.3-1.1,0.7-1.9,1.1-2.2c0.4-0.4,0.9-0.5,1.4-0.5c0.4,0,0.7,0.1,0.9,0.2 c0.2,0.1,0.4,0.3,0.4,0.6c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2c-0.3,0-0.5-0.2-0.7-0.5c-0.1-0.3-0.3-0.4-0.4-0.4 c-0.2,0-0.3,0.2-0.4,0.7l-0.3,1.6h0.7l-0.2,0.5H123.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007426654099941935070000006244859667997957016_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.6965,
    y1: 72.4574,
    x2: 141.6965,
    y2: 78.1341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007426654099941935070000006244859667997957016_)"
    },
    d: "M159.6,74c-0.2-0.2-0.7-0.2-1.2-0.2 c-0.7,0-1.2,0.1-1.5,0.4c-0.4,0.2-0.5,0.6-0.5,0.9c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.5,0.4,0.9,0.7c0.3,0.2,0.5,0.3,0.6,0.4 c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.1-0.5,0.1c-0.4,0-0.7-0.2-0.7-0.5c-0.1-0.5-0.3-0.7-0.7-0.7 c-0.2,0-0.3,0.1-0.5,0.2c0,0,0,0.1-0.1,0.1h-0.5c-0.2,0.3-0.5,0.4-0.7,0.6c-0.2,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.1-0.2-0.3-0.2-0.6c0-0.3,0.1-0.6,0.2-1.1c0.2-0.5,0.3-0.8,0.5-1c0.2-0.2,0.4-0.3,0.6-0.3c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.2,0.2-0.3,0.2-0.5c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.3-1-0.3c-0.5,0-1,0.1-1.4,0.4c-0.5,0.3-0.9,0.7-1.2,1.1 c-0.3,0.5-0.5,1-0.5,1.4v0h-0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.3,0.2c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1 c0-0.1,0-0.2,0.1-0.4l0.6-1.6c0.1-0.4,0.2-0.6,0.2-0.8c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.4-0.2-0.6-0.2c-0.4,0-0.8,0.2-1.2,0.5 l0.1-0.3h-0.9l0.4-1.5h-1.4l-0.4,1.5h-0.8l-0.2,0.5h0.8l-0.5,1.7c-0.1,0.2-0.1,0.5-0.2,0.6h-0.5c-0.2,0.3-0.3,0.4-0.5,0.4 c-0.1,0-0.1,0-0.1-0.1c0,0,0-0.1,0.1-0.3l0.9-2.9h-1.4l-0.2,0.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.7,0-1.3,0.3-1.8,1c-0.5,0.6-0.7,1.2-0.8,1.9h-0.2c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.1-0.1 c0,0,0-0.2,0.1-0.4l0.5-1.6c0.1-0.3,0.1-0.4,0.1-0.6c0-0.2-0.1-0.4-0.3-0.5c-0.2-0.1-0.4-0.2-0.7-0.2c-0.9,0-1.6,0.6-2.4,1.7 c0.1-0.3,0.1-0.5,0.1-0.7c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.2-0.4-0.2-0.7-0.2c-0.8,0-1.5,0.5-2.2,1.6c0.1-0.4,0.2-0.7,0.2-0.9 c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5,0-1,0.3-1.4,0.8c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.2-0.4 c-0.1-0.1-0.2-0.2-0.4-0.2c-0.5,0-1.2,0.7-1.9,2c0.2-0.7,0.3-1.1,0.3-1.3c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.3,0-0.7,0.1-1,0.4c-0.3,0.2-0.5,0.4-0.7,0.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.3-0.3-0.9-0.5-1.6-0.5c-0.6,0-1.1,0.1-1.5,0.4 c-0.4,0.3-0.7,0.6-0.9,1c-0.2,0.4-0.3,0.8-0.3,1.1c0,0.6,0.2,1.1,0.6,1.4c0.4,0.3,0.9,0.5,1.5,0.5c0.8,0,1.5-0.2,2-0.8 c0.5-0.5,0.8-1.1,0.8-1.8c0-0.1,0-0.2,0-0.3h0.1c0.2-0.4,0.5-0.7,0.7-0.7c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.4l-0.8,2.8h1.5 c0.2-0.6,0.4-1.3,0.8-2c0.4-0.7,0.7-1.1,0.9-1.1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1h0.5 c0.1-0.1,0.1-0.3,0.3-0.4c0.1-0.2,0.2-0.2,0.3-0.2c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0.1,0,0.2-0.1,0.4l-0.9,2.9h1.4 c0.3-0.9,0.7-1.7,1.1-2.3c0.4-0.6,0.8-0.9,1.1-0.9c0.1,0,0.2,0,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.3-0.1,0.5l-0.8,2.5h1.4 c0.2-0.9,0.6-1.6,1.1-2.3c0.5-0.7,0.9-1,1.2-1c0.2,0,0.2,0.1,0.2,0.2c0,0.1,0,0.2-0.1,0.3l-0.4,1.5c-0.1,0.3-0.1,0.5-0.1,0.6 c0,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.7-0.1,1-0.3c0.2-0.1,0.3-0.3,0.5-0.5c0,0.3,0.1,0.5,0.3,0.7 c0.2,0.2,0.4,0.3,0.6,0.3c0.5,0,1.1-0.4,1.6-1.1c0,0.1,0,0.2,0,0.3c0,0.3,0.1,0.5,0.2,0.6c0.2,0.1,0.4,0.2,0.6,0.2 c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.5,0.7-0.9c0,0.1,0,0.2,0,0.3c0,0.3,0.1,0.6,0.3,0.7c0.2,0.1,0.4,0.2,0.7,0.2 c0.4,0,0.8-0.2,1.1-0.5c0.3-0.3,0.6-0.7,0.7-1.1h-0.5c-0.2,0.5-0.5,0.8-0.7,0.8c-0.1,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.2 c0-0.1,0.1-0.3,0.2-0.7l0.6-2h0.7c-0.1,0.2-0.3,0.4-0.4,0.7h0.5c0.2-0.4,0.4-0.6,0.6-0.6c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1 s0,0.1-0.1,0.3l-0.6,1.7c-0.1,0.4-0.2,0.6-0.2,0.8c0,0.2,0.1,0.4,0.2,0.6c0.2,0.1,0.4,0.2,0.7,0.2c0.6,0,1.2-0.3,1.6-1 c0.1,0.3,0.2,0.5,0.4,0.7c0.3,0.2,0.7,0.3,1.3,0.3c0.5,0,0.9-0.1,1.4-0.3c0.3-0.2,0.6-0.4,0.8-0.7c0,0,0,0,0,0 c0,0.3,0.2,0.6,0.5,0.8c0.3,0.2,0.8,0.3,1.3,0.3c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.6,0.6-1c0-0.2-0.1-0.4-0.2-0.7 c-0.1-0.2-0.5-0.5-0.9-0.8c-0.3-0.2-0.4-0.3-0.5-0.3c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.1,0.5-0.1 c0.3,0,0.5,0.1,0.6,0.4c0.1,0.4,0.3,0.5,0.6,0.5c0.2,0,0.3-0.1,0.4-0.2s0.2-0.2,0.2-0.4C160,74.4,159.9,74.2,159.6,74z  M126.4,76.7c-0.3,0.6-0.6,0.9-1,0.9c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.4-0.2-0.7c0-0.4,0.1-0.9,0.4-1.5c0.3-0.6,0.6-1,1-1 c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.4,0.2,0.7C126.8,75.6,126.7,76.1,126.4,76.7z M144.1,75.9c-0.2,0.5-0.4,0.8-0.6,1 c-0.2,0.2-0.4,0.3-0.5,0.3c-0.1,0-0.2,0-0.2-0.1c0-0.1-0.1-0.2-0.1-0.3c0-0.3,0.1-0.8,0.4-1.5c0.3-0.6,0.6-1,0.9-1 c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3C144.4,75,144.3,75.4,144.1,75.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087405055192458847520000000513752074504140201_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.3542,
    y1: 71.184,
    x2: 151.3542,
    y2: 72.7121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBB331"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087405055192458847520000000513752074504140201_)"
    },
    d: "M151.9,71.4c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.1,0.2-0.3,0.2-0.5C152.1,71.7,152,71.6,151.9,71.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029047723106530128380000009202795113818956688_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.0323,
    y1: -10.3965,
    x2: 124.1166,
    y2: 64.9577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01440626,
    style: {
      stopColor: "#F8E8AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2205,
    style: {
      stopColor: "#CC9740"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6155,
    style: {
      stopColor: "#D9A55E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    style: {
      stopColor: "#D1A352"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    style: {
      stopColor: "#E7C979"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029047723106530128380000009202795113818956688_)"
    },
    d: "M147.1,34.8c-1.7-2.6-4.2-4.5-7.4-5.7 c2.3-1.1,4.1-2.8,5.3-5.1c1.2-2.2,1.8-4.7,1.8-7.5c0-3.6-1-6.7-3-9.4c-2-2.7-4.4-4.3-7-5c-2.6-0.7-6.6-1-11.9-1H85v0 c-0.8,0-1.6,0-2.5,0H62l0,0h-7.4v6.5C49.2,2.5,42.4,0,34.3,0c-9,0-16.1,2.9-21.3,8.7c-5.2,5.8-7.9,13.1-7.9,21.9 c0,8.4,2.6,15.7,7.7,21.8c5.1,6.1,12.9,9.2,23.4,9.2c8.7,0,15.8-2.5,21.1-7.6c5.3-5,8-11.8,8-20.1c0-0.6,0-1.3,0-2.1h-21v7.5h10.4 c-0.6,4.3-2.7,7.8-6.3,10.4c-3.6,2.6-7.7,4-12.3,4c-5.9,0-10.9-2.1-15.1-6.3c-4.2-4.2-6.3-9.8-6.3-17c0-6.2,1.8-11.5,5.5-15.9 c3.7-4.4,8.6-6.6,15-6.6c4.5,0,8.6,1.3,12.1,3.8c3.5,2.6,6,5.5,7.4,8.8H62v-12h7.2v44.8h-7.3v7.5h28.6v-7.5H77.9V38h4 c5,0,8.8-0.2,11.2-0.7c2.5-0.4,4.7-1.3,6.7-2.6c2-1.3,3.6-3.3,5-6c1.3-2.7,2-5.8,2-9.2c0-4.2-1-7.9-3-11h8.9v44.8h-7.1v7.5h19.7 c4.4,0,7.8-0.2,10.4-0.7c2.5-0.5,4.9-1.3,7-2.7c2.1-1.3,3.8-3.2,5.1-5.6c1.3-2.4,1.9-5.1,1.9-8C149.7,40.5,148.9,37.5,147.1,34.8z  M94.7,28.3c-2.2,1.7-6.1,2.5-11.8,2.5h-5V8.6h5.4c4,0,6.9,0.2,8.6,0.7c1.7,0.5,3.2,1.6,4.3,3.4c1.2,1.8,1.7,4,1.7,6.7 C98,23.7,96.9,26.6,94.7,28.3z M121.5,8.6h5.4c7.5,0,11.2,2.8,11.2,8.5c0,2.9-0.8,5.1-2.5,6.6c-1.6,1.5-4.6,2.3-8.7,2.3h-5.4V8.6z  M139.1,49.6c-1.3,1.6-2.9,2.7-4.9,3.1c-2,0.4-5.1,0.7-9.4,0.7h-3.3v-20h5c3.5,0,6.1,0.3,8,0.8c1.9,0.5,3.5,1.6,4.7,3.2 c1.2,1.6,1.8,3.6,1.8,5.9C140.9,45.9,140.3,48,139.1,49.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiesGpb);
export default __webpack_public_path__ + "static/media/studies-GPB.f90e48b0bee2603b91aa5c9c2f57fb4c.svg";
export { ForwardRef as ReactComponent };